import { getMaxInclusiveDaysAcrossYearsOfRange } from "@/lib/date";
import { DateTime } from "luxon";

export interface DateRange {
  start: Date;
  end: Date;
}

export function getCurrentYearDateRange(): DateRange {
  const now = DateTime.now();
  return {
    start: now.startOf("year").toJSDate(),
    end: now.endOf("year").toJSDate(),
  };
}

export function getInitialProjectScheduleRange(
  projectStart: Date,
  projectEnd: Date,
): DateRange {
  const yearRange = getCurrentYearDateRange();
  const start = new Date(
    Math.max(projectStart.getTime(), yearRange.start.getTime()),
  );
  const endWithinYear = new Date(
    Math.min(projectEnd.getTime(), yearRange.end.getTime()),
  );

  if (start.getTime() > endWithinYear.getTime()) {
    return { start: projectStart, end: projectStart };
  }

  const rangeDays = getMaxInclusiveDaysAcrossYearsOfRange(start, endWithinYear);
  const maxEndFromStart = DateTime.fromJSDate(start)
    .plus({ days: rangeDays - 1 })
    .endOf("day")
    .toJSDate();

  return {
    start,
    end: new Date(Math.min(endWithinYear.getTime(), maxEndFromStart.getTime())),
  };
}
